import React from 'react';

export { default } from './EntityList';